<div class='buttons-chat-bubble-container'>
    <div class='content-block'>
        @if (content?.buttons?.media) {
            <div class='image-block'>
                @switch (content?.buttons?.media.bubbleType) {
                    @case ('image') {
                        <img [src]="content?.buttons?.media.src | sanitize"
                             alt='image'/>
                    }
                    @case ('video') {
                        <app-video
                                [content]="content?.buttons?.media"
                                [messageSource]="false">
                        </app-video>
                    }
                    @case ('file') {
                        <app-file
                                [content]="content?.buttons?.media"
                                [messageSource]="false">
                        </app-file>
                    }
                }
            </div>
        }
        @if (content?.buttons?.text) {
            <p class='title'>{{ content.buttons.text }}</p>
        }

        @if (content?.buttons?.body) {
            <p class='message'>{{ content?.buttons?.body }}</p>
        }
        @if (content?.buttons?.footer) {
            <p class='desc'>{{ content?.buttons?.footer }}</p>
        }
    </div>

    @for (item of content?.buttons?.items; track item) {
        <div class="buttons-block">
            <button class="chat-button" [disabled]="activeOption"
                    (click)='sendOptionEmitter(item.postbackData, item)'>{{ item.title }}
            </button>
        </div>
    }
</div>
